import config from "config";
import React, { Fragment, useContext } from "react";
import { Button } from "react-admin";
import { PlayByPlayContext } from "games/model/PlayByPlayContext";
import _ from "lodash";
import PlayerQuickCreateButton from "./PlayerQuickCreateButton";
import axios from "axios";
import { AuthDriver as auth } from "auth";
import { useNotify } from "react-admin";
import SendIcon from "@material-ui/icons/Send";
import ClearIcon from "@material-ui/icons/Clear";
import { makeStyles } from "@material-ui/core/styles";
import WarningButton from "../components/WarningButton";
import ChangeTeamsButton from "./ChangeTeamsButton";
import { useFormState } from "react-final-form";

const useStyles = makeStyles({
  buttonInfo: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px"
  },
  buttonWrap: {
    display: "block",
    marginBottom: "20px"
  }
});

const GameActions = (props) => {
  const notify = useNotify();
  const {
    usePlayByPlay: [state, dispatch]
  } = useContext(PlayByPlayContext);
  const { game } = state;
  const classes = useStyles();
  const { values } = useFormState();

  const handleClearGame = () => {
    if (
      !window.confirm(
        "Are you sure you want to clear all plays and stats from this game?"
      )
    )
      return;
    dispatch({
      type: "clearGame"
    });
  };

  const handleCalculateStatsFromPlays = () => {
    dispatch({
      type: "calculateStatsFromPlays"
    });
  };

  const handleClearNonPointsStats = () => {
    dispatch({
      type: "clearNonPointsStats",
      payload: {
        exceptions: {
          team: [
            "totalPoints",
            "firstQuarterPoints",
            "secondQuarterPoints",
            "thirdQuarterPoints",
            "fourthQuarterPoints",
            "overtimePoints",
            "overtime2Points",
            "overtime3Points",
            "pointsAllowed"
          ]
        }
      }
    });
  };

  const handleSendToPrint = async () => {
    try {
      const session = await auth.getCurrentUser();
      const jwtAccessToken = _.get(session, "session.accessToken.jwtToken");
      const printUrl = config("backend.printUri");
      // eslint-disable-next-line no-unused-vars
      const r = await axios({
        method: "POST",
        url: printUrl,
        headers: {
          Authorization: `Bearer ${jwtAccessToken}`,
          "Content-Type": "application/json"
        },
        data: game
      });
      notify("Send to Print Success");
    } catch (e) {
      // TODO: handle failure, somehow...
      // TODO: confirm 40x handling
      console.log("handleSendToPrint():e:", e);
      console.log(JSON.stringify(e));
      notify("Send to Print Failure (Please Contact Support)", "error");
    }
  };

  const handleSendToPrint2 = async () => {
    try {
      const session = await auth.getCurrentUser();
      const jwtAccessToken = _.get(session, "session.accessToken.jwtToken");
      const printUrl = config("backend.printUri2");
      const queryData = "?game_id=" + game.id;
      // eslint-disable-next-line no-unused-vars
      const r = await axios({
        method: "POST",
        url: printUrl + queryData,
        headers: {
          Authorization: `Bearer ${jwtAccessToken}`,
        }
      });
      notify("Send to Print Success");
    } catch (e) {
      // TODO: handle failure, somehow...
      // TODO: confirm 40x handling
      console.log("handleSendToPrint2():e:", e);
      console.log(JSON.stringify(e));
      notify("Send to Print Failure (Please Contact Support)", "error");
    }
  };

  return (
    <Fragment>
      <div className={classes.buttonWrap}>
        <ChangeTeamsButton game={values} className={classes.button} />
      </div>
      <div className={classes.buttonWrap}>
        <PlayerQuickCreateButton {...props} />
      </div>
      <div className={classes.buttonWrap}>
        <Button
          label="Send to Print"
          onClick={handleSendToPrint2}
          color="primary"
          variant="outlined"
          className={classes.button}
        >
          <SendIcon />
        </Button>
      </div>
      <div className={classes.buttonWrap}>
        <Button
          label="Send to Print (Backup)"
          onClick={handleSendToPrint}
          color="primary"
          variant="outlined"
          className={classes.button}
        >
          <SendIcon />
        </Button>
      </div>
      <br></br>
      <br></br>
      <div className={classes.buttonWrap}>
        <Button
          label="Calculate Stats from Plays"
          onClick={handleCalculateStatsFromPlays}
          color="primary"
          variant="outlined"
          className={classes.button}
        />
        <i className={classes.buttonInfo}>
          This will overwrite any stats directly entered into fields.
        </i>
      </div>
      <div className={classes.buttonWrap}>
        <Button
          label="Clear all stats except for Team Points"
          onClick={handleClearNonPointsStats}
          color="primary"
          variant="outlined"
          className={classes.button}
        />
      </div>
      <div className={classes.buttonWrap}>
        <WarningButton
          label="Clear Game"
          onClick={handleClearGame}
          className={classes.button}
          variant="outlined"
        >
          <ClearIcon />
        </WarningButton>
        <i className={classes.buttonInfo}>
          This will clear ALL plays and stats from this game.
        </i>
      </div>
    </Fragment>
  );
};

export default GameActions;
